import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createAuthQuery } from '../auth-http-client';
import { DashboardSummaryParams, dashboardSummaryResponseSchema } from '../types';

export const createGetDashboardSummaryQuery = () =>
	createAuthQuery({
		params: declareParams<DashboardSummaryParams>(),
		request: {
			method: 'GET',
			url: '/dashboard/summary',
			query: ({ currency, timeZone, period }) => ({
				currency,
				timeZone,
				period,
			}),
		},
		response: {
			contract: zodContract(dashboardSummaryResponseSchema),
		},
	});
